import pptxgen from 'pptxgenjs'
import { OPEN_SANS_REGULAR } from '../common/constants'
import { percentageToInches, getCoordinates, SLIDE_SIZE_PX, decodeHtml } from '../helpers'

// NOTE: data in example:
// [
//   {
//       "labels": "Chrysler",
//       "positive": 0.6048818355572382,
//       "negative": 0.22042220933242232,
//       "neutral": 0.17469595511033936,
//       "index": 0
//   },
//   {
//       "labels": "Ford Motor",
//       "positive": 0.7023746618007558,
//       "negative": 0.23122491578608353,
//       "neutral": 0.06640042241316073,
//       "index": 1
//   },
// ]

// NOTE: data schema for pptx:
//   [
//     {
//       labels: ['Chrysler', 'Ford Motor'],
//       name: 'positive',
//       values: [0.61, 0.54],
//     },
//     {
//       labels: ['Chrysler', 'Ford Motor'],
//       name: 'neutral',
//       values: [0.19, 0.23],
//     },
//     {
//       labels: ['Chrysler', 'Ford Motor'],
//       name: 'negative',
//       values: [0.2, 0.23],
//     },
//   ]

const pptx = new pptxgen()

function renderSpacedStackBarChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)

  const xOffset = (width / 100) * 8
  const yOffset = (height / 100) * 4
  // Divide offset by two to center
  const translateY = percentageToInches(yOffset / 2 / SLIDE_SIZE_PX.y, 'y')
  const translateX = percentageToInches(xOffset / 2 / SLIDE_SIZE_PX.x, 'x')

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y + (height > 300 && translateY) - 0.5, // 0.5 is a magic number to fix "height - 150" of the chart
    h: percentageToInches((height - yOffset) / SLIDE_SIZE_PX.y, 'y') + 0.5,
    w: percentageToInches((width - xOffset) / SLIDE_SIZE_PX.x, 'x'),
  }

  const data = svgNode.properties['data-json']
  const decodedData = JSON.parse(decodeHtml(data))

  // format data to match pptx schema
  const chartData = decodedData.reduce(
    (acc, cur) => {
      const positive = {
        name: 'positive',
        labels: [...acc[0].labels, cur.labels],
        values: [...acc[0].values, cur.positive / 100],
      }
      const neutral = {
        name: 'neutral',
        labels: [...acc[1].labels, cur.labels],
        values: [...acc[1].values, cur.neutral / 100],
      }
      const negative = {
        name: 'negative',
        labels: [...acc[2].labels, cur.labels],
        values: [...acc[2].values, cur.negative / 100],
      }

      return [positive, neutral, negative]
    },
    [
      {
        name: 'positive',
        labels: [],
        values: [],
      },
      {
        name: 'neutral',
        labels: [],
        values: [],
      },
      {
        name: 'negative',
        labels: [],
        values: [],
      },
    ]
  )

  const colors = ['b81c0c', 'cfcfcf', '427c37']

  const optsChartBar2 = {
    ...chartPosition,
    barDir: 'col',
    barGrouping: 'stacked',
    barGapWidthPct: 25,

    lineDataSymbol: 'none',
    title: '',
    showTitle: false,
    lineDataSymbolSize: null,
    lineSmooth: true,

    catAxisLabelFontSize: 9,
    catAxisLabelColor: '878787',
    catAxisLabelFontFace: OPEN_SANS_REGULAR,
    catAxisLabelPos: 'low',
    catAxisLineShow: false,

    valAxisHidden: true,

    showValue: true,
    dataLabelPosition: 'b',
    dataLabelFormatCode: '#%',
    dataLabelColor: 'ffffff',
    dataLabelFontSize: 9,

    legendPos: 'b',
    showLegend: true,

    chartColors: colors,
    valGridLine: {
      style: 'none',
    },
  }

  slide.addChart(pptx.ChartType.bar, chartData.reverse(), optsChartBar2)
}

export default renderSpacedStackBarChart
